const unescape = (string) => {
  if (!string) return {}
  const stringWithoutEscape = string.replace(/\\/g, '')
  const obj = JSON.parse(stringWithoutEscape)
  return obj
}

export const prepareUserStatsData = (userStats, legacyData) => {
  if (!userStats.length) return null

  const userStatsData = userStats.reduce((acc, curr) => {
    const {
      chart_id: chartId,
      wins,
      completed_hands_all_time,
      mistaken_hands_all_time,
      fixed_mistakes,
      active_mistakes,
    } = curr
    const completedHandsAllTime = unescape(completed_hands_all_time)
    const mistakenHandsAllTime = unescape(mistaken_hands_all_time)
    const fixedMistakes = unescape(fixed_mistakes)
    const activeMistakes = unescape(active_mistakes)

    const { sweeperChartWins, sweeperChartProgress, sweeperUserStats } =
      legacyData || {}

    const legacyWins = sweeperChartWins[chartId] || 0
    const legacyChartStats = sweeperChartProgress[chartId] || {}

    const { stats } = legacyChartStats

    if (stats) {
      const {
        completedHandsAllTime: legacyCompletedHandsAllTime,
        mistakesHandsAllTime: legacyMistakenHandsAllTime,
      } = stats
      Object.values(legacyCompletedHandsAllTime || {}).forEach((hand) => {
        const handKey = `${hand[0]},${hand[1]}`
        completedHandsAllTime[handKey] =
          (completedHandsAllTime[handKey] || 0) + 1
      })
      Object.values(legacyMistakenHandsAllTime || {}).forEach((hand) => {
        const handKey = `${hand[0]},${hand[1]}`
        mistakenHandsAllTime[handKey] = (mistakenHandsAllTime[handKey] || 0) + 1
      })
    }

    if (sweeperUserStats) {
      const {
        activeMistakes: legacyActiveMistakes,
        fixedMistakes: legacyFixedMistakes,
      } = sweeperUserStats

      const chartActiveMistakes = legacyActiveMistakes[chartId]
      if (chartActiveMistakes) {
        Object.entries(chartActiveMistakes).forEach(([hand, value]) => {
          activeMistakes[hand] = (activeMistakes[hand] || 0) + value
        })
      }
      const chartFixedMistakes = legacyFixedMistakes[chartId]
      if (chartFixedMistakes) {
        Object.entries(chartFixedMistakes).forEach(([hand, value]) => {
          fixedMistakes[hand] = (fixedMistakes[hand] || 0) + value
        })
      }
    }

    const chartData = {
      chartId,
      wins: parseInt(wins) + parseInt(legacyWins),
      completedHandsAllTime,
      mistakenHandsAllTime,
      fixedMistakes,
      activeMistakes,
    }
    return { ...acc, [chartId]: chartData }
  }, {})

  if (legacyData) {
    const {
      sweeperChartWins,
      sweeperChartProgress,
      sweeperUserStats,
    } = legacyData

    Object.entries(sweeperChartProgress).forEach(([chartId, data]) => {
      const { stats } = data

      const isFound = userStatsData[chartId]
      if (!isFound) {
        const completedHandsToSet = {}
        const mistakenHandsToSet = {}
        const activeMistakesToSet = {}
        const fixedMistakesToSet = {}
        const legacyWins = sweeperChartWins[chartId] || 0

        if (stats) {
          const {
            completedHandsAllTime: legacyCompletedHandsAllTime,
            mistakesHandsAllTime: legacyMistakenHandsAllTime,
          } = stats
          Object.values(legacyCompletedHandsAllTime || {}).forEach((hand) => {
            const handKey = `${hand[0]},${hand[1]}`
            completedHandsToSet[handKey] =
              (completedHandsToSet[handKey] || 0) + 1
          })
          Object.values(legacyMistakenHandsAllTime || {}).forEach((hand) => {
            const handKey = `${hand[0]},${hand[1]}`
            mistakenHandsToSet[handKey] = (mistakenHandsToSet[handKey] || 0) + 1
          })
        }

        if (sweeperUserStats) {
          const {
            activeMistakes: legacyActiveMistakes,
            fixedMistakes: legacyFixedMistakes,
          } = sweeperUserStats

          const chartActiveMistakes = legacyActiveMistakes[chartId]
          if (chartActiveMistakes) {
            Object.entries(chartActiveMistakes || {}).forEach(
              ([hand, value]) => {
                activeMistakesToSet[hand] =
                  (activeMistakesToSet[hand] || 0) + value
              },
            )
          }
          const chartFixedMistakes = legacyFixedMistakes[chartId]
          if (chartFixedMistakes) {
            Object.entries(chartFixedMistakes || {}).forEach(
              ([hand, value]) => {
                fixedMistakesToSet[hand] =
                  (fixedMistakesToSet[hand] || 0) + value
              },
            )
          }
        }

        const chartData = {
          chartId,
          wins: legacyWins,
          completedHandsAllTime: completedHandsToSet,
          mistakenHandsAllTime: mistakenHandsToSet,
          activeMistakes: activeMistakesToSet,
          fixedMistakes: fixedMistakesToSet,
        }
        userStatsData[chartId] = chartData
      }
    })
  }

  return userStatsData
}
